export default "__VITE_ASSET__C_dQqxU5__"